import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO } from "../data/content";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/show", label: "The Show" },
  { to: "/watch", label: "Watch" },
  { to: "/cast", label: "Cast" },
  { to: "/sketches", label: "Sketches" },
  { to: "/bts", label: "Behind the Scenes" },
  { to: "/industry", label: "Licensing & Partnerships" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 inset-x-0 z-40 border-b border-white/10 bg-[#0A0A0E]/80 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0" data-testid="nav-logo" onClick={() => setOpen(false)}>
          <img src={LOGO} alt="Laugh at L.A. logo" className="h-10 w-10 object-contain" />
          <span className="font-display text-xl tracking-wide text-white hidden xs:inline sm:inline">LAUGH <span className="text-[#E11D48]">@</span> L.A.</span>
        </Link>
        <nav className="hidden lg:flex items-center gap-4 xl:gap-5" aria-label="Primary" data-testid="nav-desktop">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/[\s&]+/g, "-")}`}
              className={({ isActive }) => `link-gold text-xs xl:text-sm font-medium tracking-wide whitespace-nowrap ${isActive ? "text-[#F59E0B]" : "text-gray-300 hover:text-white"}`}>
              {n.label}
            </NavLink>
          ))}
          <Link to="/join" data-testid="nav-join-list"
            className="rounded-full bg-[#E11D48] px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#F43F5E]">
            Join the List
          </Link>
        </nav>
        <button className="lg:hidden text-white p-2" onClick={() => setOpen(!open)} aria-label="Toggle menu" aria-expanded={open} data-testid="nav-mobile-toggle">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-white/10 bg-[#0A0A0E]/95 backdrop-blur-xl px-4 py-4 flex flex-col gap-1" aria-label="Mobile" data-testid="nav-mobile">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)} data-testid={`nav-mobile-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) => `rounded-lg px-4 py-3 text-base font-medium ${isActive || (n.to === "/" && location.pathname === "/") ? "bg-white/10 text-[#F59E0B]" : "text-gray-300"}`}>
              {n.label}
            </NavLink>
          ))}
          <Link to="/join" onClick={() => setOpen(false)} data-testid="nav-mobile-join-list"
            className="mt-2 rounded-full bg-[#E11D48] px-5 py-3 text-center text-base font-semibold text-white">
            Join the List
          </Link>
        </nav>
      )}
    </header>
  );
}
